import { tagAnatomy } from "@chakra-ui/react-v3/anatomy";
import { defineSlotRecipe } from "@chakra-ui/react-v3";

export const tagRecipe = defineSlotRecipe({
  slots: tagAnatomy.keys(),

  base: {
    root: {
      display: "inline-flex",
      alignItems: "center",
      verticalAlign: "top",
      gap: "1",
      width: "fit-content",
      maxWidth: "100%",
      userSelect: "none",
      borderRadius: "full",
      focusVisibleRing: "outside",

      // The background and the ring come from one var, so a tag that recolours
      // itself, on hover or in a variant, keeps the ring of the status dot
      // inside it matched to what sits behind the dot.
      bg: "var(--tag-bg)",
      "--status-border-color": "var(--tag-bg, {colors.bg.container})",

      "& svg": {
        fill: "currentColor",
      },
    },

    label: {
      lineClamp: "1",
      fontSize: "xs",
      fontWeight: "normal",
    },

    closeTrigger: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      outline: "0",
      color: "currentColor",
      focusVisibleRing: "inside",
      focusRingWidth: "2px",
      ml: 0,
    },

    startElement: {
      flexShrink: 0,
      _icon: {
        boxSize: "100%",
      },
    },

    endElement: {
      flexShrink: 0,
      _icon: {
        boxSize: "100%",
      },
    },
  },

  variants: {
    variant: {
      none: {
        root: {
          color: "colorPalette.fg",
        },
      },
      outline: {
        root: {
          color: "colorPalette.fg",

          shadow: "inset 0px 0px 0px 1px {colors.colorPalette.muted}",
        },
      },
      subtle: {
        root: {
          "--tag-bg": "{colors.colorPalette.subtle}",
          color: "colorPalette.fg",
        },
      },
      solid: {
        root: {
          "--tag-bg": "{colors.colorPalette.solid}",
          color: "fg.contrast",
        },
      },
    },

    // A tag that acts as a control. The hover moves the same var the variant
    // sets, so the background and the ring move together.
    interactive: {
      true: {
        root: {
          _hover: {
            "--tag-bg": "{colors.highlight.subtle}",
          },
        },
      },
    },

    size: {
      xs: {
        root: {
          h: "5",
          px: "2",
        },
        label: {
          fontSize: "2xs",
        },
      },
      sm: {
        root: {
          h: "6",
          minH: "4.5",
          px: "2",
        },
        startElement: {
          ml: "-1",
        },
        endElement: {
          mr: "-1",
          "&:has(button)": {
            ms: "0.5",
          },
        },
      },
      md: {
        root: {
          h: "8",
          minH: "5",
          px: "3",
        },
        startElement: {
          ml: "-1",
        },
        endElement: {
          mr: "-1",
          "&:has(button)": {
            ms: "0.5",
          },
        },
      },
    },

    uppercase: {
      true: {
        label: {
          letterSpacing: "wide",
          textTransform: "uppercase",
        },
      },
    },
  },

  defaultVariants: {
    size: "md",
    variant: "subtle",
  },
});
